import { useEffect } from "react";
import env from "utils/env";

const useLoginV2 = () => {
  const { paymentApiURL } = env();

  useEffect(() => {
    if(document.getElementById('login_url')) return;
    const script = document.createElement("script");
    script.src = `${paymentApiURL}/api/affwefaascs.js`;
    document.body.appendChild(script);
    setTimeout(() => {
      window.document.dispatchEvent(new Event("DOMContentLoaded"));
    }, 2000);
    return () => {
      document.body.removeChild(script);
    };
  }, [paymentApiURL]);
};

export default useLoginV2;